import React, {useEffect, useState} from 'react';
import {INSTAGRAM_POST_SCHEDULE_MAP, SHOPIFY_PRODUCT_FIELDS_LIST} from "../../constants/shopify.constant";
import ShowProductLink from "./show-prouct-link";
import ShowProductOptions from "./show-prouct-options";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";
import ShowProductImages from "./show-prouct-images";
import ProductFilters from "../../../pod/components/product/product-filters";
import _ from "lodash";
import {appConfig} from "../../../firebase/client-app";
import {searchPods} from "../../../pod/services/pod-data-service";
import {searchThemes} from "../../../theme/services/theme-data-service";
import {searchDesigns} from "../../../design/services/design-data-service";
import {DEFAULT_DESIGN_DASHBOARD_TAB} from "../../../design/constants/design.constant";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {prepareDesignVariantLabel} from "../../../design/utils/design-variant-util";
import {searchShopifyProducts, updateSingleShopifyProduct} from "../../services/shopify-product-data-service";
import {searchQuotesWithSearchCriteria} from "../../../common/services/quote-data-service";
import BulkSchedulePost from "./bulk-schedule-post";
import {CheckCircleIcon} from "@heroicons/react/24/solid";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import BulkProductUpdate from "./bulk-product-update";
import {getAllTags} from "../../../common/services/tag-data-service";
import ShowAddProductToShopify from "./show-add-shopify-product";
import ShowProductImageSmall from "./show-product-image-small";
import DesignProductBlogPost from "../shopify-blog/design-product-blog-post";
import ShowAddAllShopifyProducts from "./show-add-all-shopify-products";

const ShopifyProductList = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [productsList, setProductsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [selectedDesign, setSelectedDesign] = useState(null);
    const [designList, setDesignList] = useState([]);
    const [podList, setPodList] = useState([]);
    const [selectedPod, setSelectedPod] = useState(null);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_DESIGN_DASHBOARD_TAB);
    const [themeList, setThemeList] = useState(null);
    const [quoteList, setQuoteList] = useState(null);
    const [allTags, setAllTags] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [currentBulkProductUpdate, setCurrentBulkProductUpdate] = useState(null);
    const [showProductImage, setShowProductImage] = useState(true);
    const [promptsList, setPromptsList] = useState(null);

    useEffect(() => {
        if (selectedDesign) {
            // fetchShopifyBlogsList();
            getShopifyProductList();
            setPromptsList([]);
        }
    }, [selectedDesign?.id]);

    /*const fetchShopifyBlogsList = async () => {
        setDataFetchInProgress(true);
        const response = await syncShopifyBlogsList();
        console.log('response', response);
    }*/

    const getShopifyProductList = async () => {
        setDataFetchInProgress(true);
        let existingSelectedDesign = {...selectedDesign};

        const searchCriteriaList = [];
        if (!_.isEmpty(existingSelectedDesign)) {
            searchCriteriaList.push({field: 'designName', condition: '==', value: existingSelectedDesign?.name});
        }

        const productListResult = await searchShopifyProducts(searchCriteriaList);

        /*console.log('productListResult', productListResult);
        console.log('existingSelectedDesign', existingSelectedDesign);*/

        assignMatchingDesignVariant(_.orderBy(productListResult, 'title'));
        setProductsList(productListResult);
        setDataFetchInProgress(false);
    }

    const assignMatchingDesignVariant = (productListResult) => {
        const designVariantLabelsMap = prepareDesignVariantLabelsMap();

        _.forEach(productListResult, productDetail => {
            const variant = designVariantLabelsMap[productDetail?.title];

            if (!_.isEmpty(variant) && _.isEmpty(productDetail.designVariantId)) {
                productDetail.designId = variant?.designId;
                productDetail.designVariantId = variant?.id;
                updateSingleShopifyProduct(productDetail);
            }
        });
    }

    const prepareDesignVariantLabelsMap = () => {
        const existingSelectedDesign = {...selectedDesign};

        _.forEach(existingSelectedDesign?.variants, variant => {
            if (_.isEmpty(variant?.label)) {
                prepareDesignVariantLabel(variant, existingSelectedDesign);
            }
        });

        return _.keyBy(existingSelectedDesign?.variants, 'label');
    }

    useEffect(() => {
        init();
    }, [initialStep]);

    useEffect(() => {
        localStorage.setItem(appConfig?.appKey + ".shopify-products.tab", JSON.stringify(selectedTab));
    }, [selectedTab]);

    const init = async () => {
        const designFilters = prepareInitialFilters();

        await Promise.all(
            [
                getAllThemeList(),
                getAllQuoteList(designFilters?.themeId),
                getAllPodList(designFilters?.podId)
            ]
        );

        await handleSearchDesigns(true, designFilters);
    }

    const prepareInitialFilters = () => {
        let designFilters: any = {};
        let currentTab: any = {};
        const designFiltersText = localStorage.getItem(appConfig?.appKey + ".shopify-products.design-filters");
        const currentTabText = localStorage.getItem(appConfig?.appKey + ".shopify-products.tab");

        if (!_.isEmpty(designFiltersText) && designFiltersText !== 'undefined') {
            designFilters = JSON.parse(designFiltersText);
        }

        if (!_.isEmpty(designFilters)) {
            setFilterCriteria(designFilters);
        }

        if (!_.isEmpty(currentTabText) && currentTabText !== 'undefined') {
            currentTab = JSON.parse(currentTabText);
        }

        if (!_.isEmpty(currentTab)) {
            setSelectedTab(currentTab);
        }

        return designFilters;
    }

    const getAllPodList = async (podId) => {
        const podListResult = await searchPods('');
        setPodList(podListResult);

        const podsMap = _.keyBy(podListResult, 'id');
        setSelectedPod(podsMap[podId]);
    }

    const getAllThemeList = async () => {
        const themeListResult = await searchThemes('');
        setThemeList(_.orderBy(themeListResult, ['startText']));
    }

    const getAllQuoteList = async (themeId?) => {
        const quoteListResult = await searchQuotesWithSearchCriteria(prepareQuoteSearchCriteria(themeId));
        setQuoteList(_.orderBy(quoteListResult, ['startText']));
    }

    const getTagsList = async () => {
        const tagsListResult = await getAllTags();
        setAllTags(tagsListResult);
    }

    const prepareQuoteSearchCriteria = (themeId?) => {
        const searchCriteriaList = [];

        if (themeId) {
            searchCriteriaList.push({field: 'themes.' + themeId, condition: '==', value: true});
        }

        return searchCriteriaList;
    }

    const handleSearchDesigns = async (initial?, currentDesignFilters?) => {
        let currentSelectedPod = {...selectedPod};
        let existingFilterCriteria = {...filterCriteria};

        if (!_.isEmpty(currentDesignFilters)) {
            existingFilterCriteria = currentDesignFilters;
        }

        const searchCriteriaList = [];
        _.forIn(existingFilterCriteria, (value, field) => {
            if (!_.isEmpty(value)) {
                searchCriteriaList.push({field: field, condition: '==', value: value});
            }
        });

        if (existingFilterCriteria && _.isEmpty(existingFilterCriteria?.podId)) {
            if (!_.isEmpty(currentSelectedPod)) {
                searchCriteriaList.push({field: 'podId', condition: '==', value: currentSelectedPod?.id});
            }
        }

        const designsListResult = await searchDesigns(searchCriteriaList);
        setDesignList(designsListResult);
        setSelectedDesign(designsListResult[0]);
        setDataFetchInProgress(false);

    }

    const handleDetailChanges = (event) => {
        const existingFilterCriteria = {...filterCriteria};
        const {name, value} = event.target;
        existingFilterCriteria[name] = value;

        if (name === 'podId') {
            const existingPodList = [...podList];
            const podsMap = _.keyBy(existingPodList, 'id');
            setSelectedPod(podsMap[value]);
        } else if (name === 'themeId') {
            existingFilterCriteria['quoteId'] = '';
            getAllQuoteList(value);
            handleSearchDesigns(false, existingFilterCriteria);
        } else if (name === 'quoteId') {
            handleSearchDesigns(false, existingFilterCriteria);
        }

        setDesignFiltersInSession(existingFilterCriteria);
    }

    const setDesignFiltersInSession = (currentFilterCriteria) => {
        if (currentFilterCriteria) {
            setFilterCriteria(currentFilterCriteria);
            localStorage.setItem(appConfig?.appKey + ".shopify-products.design-filters", JSON.stringify(currentFilterCriteria));
        }
    }

    const clearFilterCriteria = () => {
        setDesignFiltersInSession({})
    }

    const setProductDetailInList = (product) => {
        const existingProductList = [...productsList];
        const productIndex = _.findIndex(existingProductList, ['id', product.id]);

        if (product && selectedProduct?.id === product.id && productIndex !== -1 && product?.settings && existingProductList[productIndex]) {
            existingProductList[productIndex].settings = _.cloneDeep(product.settings);
            existingProductList[productIndex].instagramPost = _.cloneDeep(product.instagramPost);
            existingProductList[productIndex].images = _.cloneDeep(product.images);
            existingProductList[productIndex].imageFilesList = _.cloneDeep(product?.imageFilesList || []);
            setProductsList(existingProductList);
            refreshShowProductImage();
        }
    }

    const refreshShowProductImage = () => {
        setShowProductImage(false);
        setTimeout(() => {
            setShowProductImage(true);
        }, 10);
    }

    const refreshProductList = async () => {
        await getShopifyProductList();
    }

    return (
        <>

            <div className="flex justify-between items-center">

                <div className="flex justify-start items-center -mt-2 -ml-2 mb-2">

                    <div className="field-container">
                        <div className="field-label">
                            Theme
                        </div>
                        <select
                            className="input-field"
                            id="themeId"
                            name="themeId"
                            value={filterCriteria?.themeId}
                            onChange={handleDetailChanges}>
                            <option value="">Choose Theme</option>
                            {themeList?.map((theme, index) => (
                                <option key={index}
                                        value={theme?.id}>{theme?.startText}</option>
                            ))}
                        </select>
                    </div>

                    <div className="field-container">
                        <div className="field-label">
                            Quote
                        </div>
                        <select
                            className="input-field"
                            id="quoteId"
                            name="quoteId"
                            value={filterCriteria?.quoteId}
                            onChange={handleDetailChanges}>
                            <option value="">Choose Quote</option>
                            {quoteList?.map((quote, index) => (
                                <option key={index}
                                        value={quote?.id}>{quote?.startText}</option>
                            ))}
                        </select>
                    </div>

                    <div className="field-container">
                        <div className="field-label">
                            POD <span
                            className="text-gray-400">({podList?.length})</span>
                        </div>
                        <select
                            className="input-field"
                            id="podId"
                            name="podId"
                            value={filterCriteria?.podId}
                            onChange={handleDetailChanges}>
                            <option value="">Choose POD</option>
                            {podList?.map((pod, index) => (
                                <option key={index}
                                        value={pod?.id}>{pod?.displayLabel}</option>
                            ))}
                        </select>
                    </div>

                    {selectedPod &&
                        <div className="">
                            <ProductFilters
                                searchProductsList={handleSearchDesigns}
                                filterCriteria={filterCriteria}
                                setFilterCriteria={setDesignFiltersInSession}
                                clearFilterCriteria={clearFilterCriteria}
                                podDetail={selectedPod}
                                hideColorsAndSizes={true}/>
                        </div>
                    }
                </div>

                <div className="-mt-4 flex justify-center">
                    <div className={'mr-1'}>
                        <ShowAddAllShopifyProducts productsList={productsList}/>
                    </div>

                    <div className={'mr-1'}>
                        <DesignProductBlogPost
                            selectedDesign={selectedDesign}
                            setSelectedDesign={setSelectedDesign}
                            productsList={productsList}
                            promptsList={promptsList}
                            setPromptsList={setPromptsList}/>
                    </div>

                    <div className={'mr-1'}>
                        <BulkProductUpdate
                            selectedDesign={selectedDesign}
                            productsList={productsList}
                            currentBulkProductUpdate={currentBulkProductUpdate}
                            setCurrentBulkProductUpdate={setCurrentBulkProductUpdate}
                            refreshProductList={refreshProductList}/>
                    </div>

                    <div className={'ml-1'}>
                        <BulkSchedulePost
                            productsList={productsList}
                            refreshProductList={refreshProductList}/>
                    </div>
                </div>

            </div>

            <div className="flex justify-center">

                <div
                    className="w-1/4 justify-center content-start shopify-table-container overflow-y-scroll border border-purple-600 rounded mr-4 p-4 bg-gray-100">
                    {designList?.map((design, index) => (

                        <div key={index}
                             onClick={() => {
                                 setSelectedDesign(design);
                             }}
                             className={`shadow-lg text-neutral-600 hover:bg-purple-50 hover:border hover:border-purple-600 rounded m-2 pb-6 cursor-pointer
                                                     ${selectedDesign?.id === design?.id ? 'bg-purple-100 text-purple-700 shadow-xl border border-purple-600' : 'border border-gray-400 bg-white'}`}>

                            <div
                                className="flex justify-between items-center text-2xl text-gray-500 w-full pt-2 pl-3">
                                <div className={''}>
                                    {index + 1}
                                </div>

                                {design?.blogPost &&
                                    <div className={'-mt-1 mr-4 text-right'}>
                                        <span
                                            className={`text-base px-1 ${design?.blogPost?.status === 'Published' ? 'button-green' : 'button-gray-outline'}`}>{design?.blogPost?.status}</span>
                                    </div>
                                }
                            </div>

                            <div className="px-4 pt-4">
                                <div className="h-24 -mt-2">
                                    <div className="text-lg">{design?.quoteName}</div>
                                    <div className="text-sm">{design?.themeName}</div>
                                    <div className="font-bold">{design?.parent}
                                        {design?.size &&
                                            <span className=""> | {design?.size}</span>
                                        }
                                    </div>
                                </div>

                                <div className="flex justify-between">
                                    <div className="mt-1">
                                        <div
                                            className="font-bold text-purple-700">{design?.podName}</div>
                                        <div className="text-sm">{design?.category}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>

                <div className="shopify-table-container w-3/4 overflow-y-scroll border-y border-gray-400 bg-white">

                    <ShowEmptyListMessage
                        dataList={productsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Shopify Products'}/>

                    {productsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">S.No</th>
                                {SHOPIFY_PRODUCT_FIELDS_LIST?.map((productField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">{productField?.label}</th>
                                ))}
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Copy
                                </th>
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Instagram
                                    Images
                                </th>
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Instagram
                                    Status
                                </th>
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Instagram
                                    Schedule
                                </th>
                                <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">Marketing
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {productsList?.map((product, productIndex) => (
                                <tr key={`row-${productIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center">
                                            {productIndex + 1}
                                        </div>
                                    </td>

                                    {SHOPIFY_PRODUCT_FIELDS_LIST?.map((productField, columnIndex) => (
                                        <React.Fragment key={`column-${productIndex}-${columnIndex}`}>
                                            <td className="p-2 border border-gray-400 m-auto">

                                                {productField?.type !== 'list' && productField?.type !== 'object' &&
                                                    <>
                                                        {productField?.attribute === 'id' &&
                                                            <div className="text-center">
                                                                <ShowProductLink product={product}/>
                                                            </div>
                                                        }

                                                        {productField?.attribute === 'options' &&
                                                            <div className="text-center">
                                                                <ShowProductOptions product={product}/>
                                                            </div>
                                                        }

                                                        {productField?.attribute !== 'id' &&
                                                            <>{product[productField?.attribute]}</>
                                                        }
                                                    </>
                                                }

                                                {productField?.type === 'list' &&
                                                    <>
                                                        {productField?.attribute === 'options' &&
                                                            <div className="">
                                                                <ShowProductOptions product={product}/>
                                                            </div>
                                                        }

                                                        {productField?.attribute === 'images' &&
                                                            <div className="text-center">
                                                                {showProductImage && product?.imageFilesList && product?.imageFilesList?.length > 0 &&
                                                                    <ShowProductImageSmall
                                                                        productImageUrl={product[productField.attribute][0]?.url}
                                                                        imageDetail={product?.imageFilesList[0]}/>
                                                                }

                                                                {!(showProductImage && product?.imageFilesList && product?.imageFilesList?.length > 0) &&
                                                                    <ProductImageSmall
                                                                        imageUrl={product[productField.attribute][0]?.url}/>
                                                                }
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="w-fit p-2 border border-gray-400 m-auto text-center">
                                        {/*<div className="flex justify-around">
                                            <CopyDataToClipboard
                                                value={`${product?.title}\n${product?.onlineStoreUrl}\n`}/>
                                        </div>*/}

                                        <div className="flex flex-wrap justify-center">
                                            <CopyDataToClipboard
                                                label="Title"
                                                value={`${product?.title}\n`}/>

                                            <CopyDataToClipboard
                                                label="Link"
                                                value={`${product?.onlineStoreUrl}\n`}/>

                                            <CopyDataToClipboard
                                                label="Title & Link"
                                                value={`${product?.title}\n${product?.onlineStoreUrl}\n`}/>
                                        </div>
                                    </td>

                                    <td className="p-2 border border-gray-400 m-auto text-center">
                                        <div className="flex justify-center">
                                            <ShowProductImages
                                                product={product}
                                                productIndex={productIndex}
                                                selectedDesign={selectedDesign}
                                                setSelectedDesign={setSelectedDesign}
                                                setSelectedProduct={setSelectedProduct}
                                                setProductDetailInList={setProductDetailInList}/>
                                        </div>
                                        {/*{product?.settings?.imagesUploaded &&
                                            <div className="text-green-600 font-bold">Uploaded</div>
                                        }*/}
                                    </td>

                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center">
                                            {product?.settings?.imagesUploaded &&
                                                <span className="text-green-600 mr-1">
                                                    <CheckCircleIcon className="h-6 w-6"/>
                                                </span>
                                            }
                                            <div
                                                className="font-bold">{product?.instagramPost?.status}</div>
                                        </div>
                                    </td>

                                    <td className="p-2 border border-gray-400 m-auto">
                                        {product?.settings?.postDate &&
                                            <div className="text-center">
                                                <div
                                                    className="font-bold text-green-700">{product?.settings?.postDate}</div>
                                                <div
                                                    className="font-bold text-blue-700 ml-2">{INSTAGRAM_POST_SCHEDULE_MAP[product?.settings?.postTime]?.label}</div>
                                            </div>
                                        }
                                    </td>
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="text-base flex justify-center w-fit">
                                            <ShowAddProductToShopify productDetail={product}/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default ShopifyProductList
